import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {MatToolbarModule} from '@angular/material/toolbar';

import {FuseSearchBarModule, FuseShortcutsModule} from '@fuse/components';
import {FuseSharedModule} from '@fuse/shared.module';

import {ToolbarComponent} from 'app/layout/components/toolbar/toolbar.component';
import {MatTooltipModule} from '@angular/material/tooltip';
import {AppMenuComponent} from './app-menu/app-menu.component';
import {MatDividerModule} from '@angular/material/divider';
import {UserPhotoModule} from '../../../components';
import {PipesModule} from '../../../pipes/pipes.module';
import {LayoutMenuComponent} from './layout-menu/layout-menu.component';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';

@NgModule({
    declarations: [
        ToolbarComponent,
        AppMenuComponent,
        LayoutMenuComponent
    ],
    imports: [
        RouterModule,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        MatToolbarModule,

        PipesModule,
        UserPhotoModule,
        FuseSharedModule,
        MatTooltipModule,
        MatDividerModule,
        FuseSearchBarModule,
        FuseShortcutsModule,
        MatSlideToggleModule,
    ],
    exports: [
        ToolbarComponent
    ]
})
export class ToolbarModule {
}
